module.exports = __webpack_public_path__ + "static/img/second.d008630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/second.png
// module id = s1jE
// module chunks = 1